import React, { useContext, useEffect } from "react";
import { NavContext } from "../../state/NavContext";
import { SideContext } from "../../state/SideContext";
import TableGames from "./components/TableGames";

const AllGames = () => {
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);

  useEffect(() => {
    setSideIndex("all-games");
    setActiveIndex("admin");
    setIsSideBarActive(true);
  }, [setActiveIndex, setIsSideBarActive, setSideIndex]);

  return (
    <>
      <div style={{ width: "100%", minHeight: 400 }}>
        <TableGames />
      </div>
    </>
  );
};

export default AllGames;
